import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ReconciliationReportConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/reconciliation-report",
    component: React.lazy(() => import("./reconciliation-report")),
  },
];
